import React from "react";
import styles from "./index.module.scss";
export default class LargeToggle extends React.Component {
    click = (value) => {
        if (!this.props.disabled) {
            this.props.optionSelected(this.props.name, value);
        }
    };
    handleErrors = () => {
        if (this.props.error) {
            this.props.setErrors({});
        }
    };
    render() {
        const smallWidth = this.props.options.length > 3 ? styles.four : "";
        const buttons = this.props.options.map(({ label, icon: Icon, value, size: Size }) => {
            const withIcon = Icon === undefined ? "" : styles.withIcon;
            const selected = this.props.selected === value;
            const long = this.props.long ? styles.long : "";
            const height = this.props.height
                ? styles[`${this.props.height}Height`]
                : styles["largeHeight"];
            return (React.createElement("button", { name: this.props.name, key: `${label} ${selected}`, onClick: () => this.click(value), type: "button", className: `${styles.option} ${long} ${smallWidth} ${height} ${this.props.disabled ? styles.disabled : ""} ${selected
                    ? styles.selected
                    : this.props.error
                        ? styles.error
                        : ""} ${this.props.small ? styles.small : ""} ${this.props.green ? styles.green : ""} ${this.props.lightGreen ? styles.lightGreen : ""} ${this.props.newDesign ? styles.newDesign : ""}` },
                Icon !== undefined && (React.createElement("div", { className: styles.icon },
                    this.props.newDesign &&
                        (selected ? (React.createElement(Icon, { primary: true, size: "24px" })) : (React.createElement(Icon, { dark: true, size: "24px" }))),
                    !this.props.newDesign &&
                        Size !== undefined &&
                        (selected ? (React.createElement(Icon, { light: true, size: "2em" })) : (React.createElement(Icon, { dark: true, size: "2em" }))),
                    !this.props.newDesign &&
                        Size === undefined &&
                        (selected ? (React.createElement(Icon, { light: true, size: "2.5em" })) : (React.createElement(Icon, { dark: true, size: "2.5em" }))))),
                this.props.newDesign &&
                    typeof label === "string" &&
                    /^\d+\s+months?$/i.test(label) ? (React.createElement("div", { className: styles.twoLineText },
                    React.createElement("div", { className: styles.numberText }, label.split(/\s+/)[0]),
                    React.createElement("div", { className: styles.unitText }, label.split(/\s+/).slice(1).join(" ")))) : (React.createElement("div", { className: `${styles.text} ${long} ${withIcon} ` }, label))));
        });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { onFocus: this.handleErrors, className: `${styles.buttons} ${this.props.small ? styles.small : ""} ${this.props.reducedWidth ? styles.reducedWidth : ""} ${this.props.newDesign ? styles.newDesignButtons : ""}` }, buttons)));
    }
}
